<template>
    <li class="w-full">
        <a href="javascript:void(0)" @click="toggleSubMenu(props.menuId)"
            :class="['flex flex-col gap-3 px-4 py-2 backdrop-blur-xl border border-white/20 dark:border-none dark:text-white text-gray-800 hover:text-indigo-600', subMenu === props.menuId ? 'bg-gray-100 dark:bg-gray-950' : '']">
            <div v-if="props.route !== ''">
                <routerLink :to="{name: props.route}" class="flex items-center gap-1">
                    <span class="p-2"> <font-awesome-icon :icon="['', props.icon]" class="fm:text-sm"/></span>
                    <span class="font-semibold tracking-wide fm:text-sm">{{ props.title }}</span>
                    <span v-if="props.badgeCount > 0" class="bg-red-500 px-2 py-1 rounded-full text-xs text-white !font-bold">{{ props.badgeCount }}</span>
                </routerLink>
            </div>
            <div v-else class="flex items-center justify-between">
                <div class="flex items-center gap-1">
                    <span class="p-2"> <font-awesome-icon :icon="['', props.icon]"/></span>
                    <span class="font-semibold tracking-wide">{{ props.title }}</span>
                    <span v-if="props.badgeCount > 0" class="bg-red-500 px-2 py-1 rounded-full text-xs text-white !font-bold">{{ props.badgeCount }}</span>
                </div>
                <span><font-awesome-icon :icon="['fm:text-sm', subMenu !== props.menuId ? 'chevron-left' : 'chevron-down']"/></span>
            </div>
        </a>
        <ul v-show="subMenu === props.menuId" class="w-full">
            <li class="bg-white/40 dark:bg-gray-900 dark:text-white backdrop-blur-md border border-white/20 dark:border-none pr-8 hover:bg-gray-200 dark:hover:bg-gray-800 text-black transition duration-300 ease-in-out" v-for="(subMenuItem, index) in props.subMenus" :key="index">
                <routerLink :to="subMenuItem.params !== undefined ? {name: subMenuItem.routeName, params:subMenuItem.params} : {name: subMenuItem.routeName}" class="flex items-center gap-3 px-3 py-3" v-if=" (subMenuItem.perm === undefined || $store.getters.userCan(subMenuItem.perm,'include'))">
                    <span class="font-medium fm:text-sm">{{ subMenuItem.title }}</span>
                </routerLink>
            </li>
        </ul>
    </li>

</template>

<script>
    export default {
        name: 'DashboardSidebar'
    }
</script>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    menuId: {
        type: Number,
        required: true
    },
    route:{
        type: String,
        required: false,
        default: ''
    },
    title: {
        type: String,
        required: true
    },
    badgeCount:{
        type: Number,
        required: false,
        default: 0
    },
    icon:{
        type: String,
        required: true
    },
    subMenus: {
        type: Array,
        required: false,
        default: () => []
    },
});

let subMenu = ref(-1);

function toggleSubMenu(_subMenu) {
    if(_subMenu == subMenu.value){
        subMenu.value = -1;
    }else{
        subMenu.value = _subMenu;
    }
}

</script>